const sleep = (wait) => new Promise((resolve) => setTimeout(resolve, wait));

export default sleep;
